import '../App.css'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import CalendarData from '../components/Calendar.json'
import EventCalendarRow from '../components/EventCalendarRow'
import EventDetails from '../components/EventDetails'
import Spinner from '../components/Spinner'

export default function Events() {
    const [futureCardComp, setFutureCardComp] = useState(<></>);
    const [pastCardComp, setPastCardComp] = useState(<></>);
    const [eventData, setEventData] = useState()
    const [loading, setLoading] = useState(true);

    const formatDate = function (d) {
        var date = new Date(d);
        var res = '';
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1);
        var yyyy = date.getFullYear();
        var HH = date.getHours();
        var MM = String(date.getMinutes());
        var AMPM = HH >= 12 ? 'pm' : 'am';
        HH = HH % 12;
        HH = HH ? HH : 12;
        MM = MM < 10 ? '0' + MM : MM;
        res = mm + '/' + dd + '/' + yyyy + ' ' + HH + ":" + MM + AMPM;
        return res
    }

    const initData = function () {
        var afterToday = [];
        var beforeToday = [];

        let calendarTest = CalendarData
        let tempSpecial = calendarTest.find(s => s.id == 3)
        setEventData(tempSpecial)

        for (let i = 0; i < CalendarData.length; i++) {
            if (new Date(CalendarData[i].end) >= Date.now() || CalendarData[i].start == "TBD") {
                afterToday.push(CalendarData[i])
            }
        }

        for (let i = 0; i < CalendarData.length; i++) {
            if (new Date(CalendarData[i].end) <= Date.now()) {
                beforeToday.push(CalendarData[i])
            }
        }

        var tempFuture = [];
        tempFuture = afterToday.sort((a, b) => {
            return new Date(a.start) - new Date(b.start)
        })

        var tempPast = [];
        tempPast = beforeToday.sort((b, a) => {
            return new Date(a.start) - new Date(b.start)
        })

        var futureComp = [];
        for (let c = 0; c < tempFuture.length; c++) {
            futureComp.push(<EventCalendarRow data={tempFuture[c]} key={tempFuture[c].id} />)
        }

        var pastComp = [];
        for (let p = 0; p < tempPast.length; p++) {
            pastComp.push(<EventCalendarRow data={tempPast[p]} key={tempPast[p].id} />)
        }

        setFutureCardComp(futureComp)
        setPastCardComp(pastComp)

        if (futureComp.length < 1) {
            setFutureCardComp(<i>No upcoming events currently</i>)
        }

        if (pastComp.length < 1) {
            setPastCardComp(<i>No past events currently</i>)
        }
        setLoading(false)
    }

    useEffect(() => {
        initData();
    }, []);

    return (
        <div>
            <main className='flex-shrink-0 modular min-vh-100'>
                <div className='container py-4'>
                    <div className='row pb -4'>
                        {loading ?
                            <>
                                <Spinner />
                            </> : <>
                                <div className='card mb-4'>
                                    <div className='row px-3 py-3'>
                                        <div className='col-9'>
                                            <h5 className='fw-bold'>{eventData.title}</h5>
                                            <p>({formatDate(eventData.start)} - {formatDate(eventData.end)})</p>
                                            <p>A recording of the 2025 Water Symposium is available on the Parker County Commissioner’s Court website: <a target="_blank" href="https://parkercountytx.new.swagit.com/videos/362135">https://parkercountytx.new.swagit.com/videos/362135</a></p>
                                        </div>
                                        <div className='col-3'>
                                            <h5 className='fw-bold text-center'>Document(s)</h5>
                                            <div className='m-2 btn d-block docBtn' style={{ backgroundColor: '#FAAB53' }}>
                                                <a href={eventData.agenda} target='_blank' className='text-light' style={{ textDecoration: 'none' }}>View Agenda</a>
                                            </div>
                                            <div className='m-2 btn d-block docBtn' style={{ backgroundColor: '#FAAB53' }}>
                                                <a href={eventData.meetingMaterials} target='_blank' className='text-light' style={{ textDecoration: 'none' }}>View Meeting Materials</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                    <div className='row pb-4'>
                        <div className='card px-0'>
                            <div className='card-header' >
                                <h3 className='text-light'>
                                    Ongoing and Upcoming Events
                                </h3>
                            </div>
                            <div className='card-body'>
                                {futureCardComp}
                            </div>
                        </div>
                    </div>
                    <div className='row pb-4'>
                        <div className='card px-0'>
                            <div className='card-header' >
                                <h3 className='text-light'>
                                    Past Events
                                </h3>
                            </div>
                            <div className='card-body'>
                                {pastCardComp}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}